import { Grid, type GridProps } from '@chakra-ui/react';

export type TwoColumnAutoGridProps = GridProps & {
	minChildWidth?: string;
};

const TwoColumnAutoGrid = ({
	children,
	minChildWidth = '280px',
	...rest
}: TwoColumnAutoGridProps) => {
	return (
		<Grid
			templateColumns={`repeat(auto-fit, minmax(${minChildWidth}, 1fr))`}
			{...rest}
		>
			{children}
		</Grid>
	);
};

export default TwoColumnAutoGrid;